import { ReactElement } from 'react';

import DefaultPopup, { IDefaultPopup } from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { Close } from '@r1-frontend/ui-react/components/svg/main';

import * as ST from './styled';

interface IProps extends IDefaultPopup {
    message: string,
    positive?: boolean,
    icon?: boolean,
    text?: string,
    buttons: (onClose: () => void) => ReactElement[],
}

export const LkPromotionalPopupExtra = ({
    message,
    positive,
    icon = true,
    text,
    buttons,
    onClose,
    ...props
}: IProps) => {
    return (
        <DefaultPopup onClose={onClose} {...props}>
            <ST.PopupWrapper data-test='content'>
                {icon && (
                    positive
                        ? <ST.PopupSuccessIcon
                            size={62}
                            strokeWidth={1.5}
                            data-test='lkPromotionalPopupExtra-icon-success'
                        />
                        : <ST.PopupErrorIcon data-test='lkPromotionalPopupExtra-icon-error'>
                            <Close size={38} strokeWidth={1.5}/>
                        </ST.PopupErrorIcon>
                )}
                <ST.PopupTitle data-test='LkPromotionalPopupExtra-title'>
                    {message}
                </ST.PopupTitle>
                {text && <ST.PopupText>
                    {text}
                </ST.PopupText>}
                <ST.PopupButtonsWrapper data-test='LkPromotionalPopupExtra-buttons'>
                    {buttons(onClose)}
                </ST.PopupButtonsWrapper>
            </ST.PopupWrapper>
        </DefaultPopup>
    );
};
